import logoRhinoLight from './logo-rhino-light.svg'
import rhinoSolo from './logo-rhino-solo.svg'
import type { ThemeAssets } from './assets.types'
import type { ThemeName } from '../store/slices/types/PortalReducerState'

const rhinoAssets: ThemeAssets = {
  logo: logoRhinoLight,
  solo: rhinoSolo,
}

const darkAssets: ThemeAssets = {
  logo: logoRhinoLight,
  solo: rhinoSolo,
}

export const themeAssets: Record<ThemeName, ThemeAssets> = {
  dark: darkAssets,
  rhino: rhinoAssets,
}
